import useGetTourConsents from '@/features/dashboard/tourConsents/hooks/useGetTourConsents.ts';

/**
 * Dokumenty do ponownej akceptacji w kroku W2 — po prostu zgody wyjazdu.
 *
 * Nie ma czego liczyć per paczka: wszystkie dokumenty są opcjonalne, a system
 * jedynie podpowiada zaznaczenie (patrz `isDocumentRecommended`). O tym, co
 * klient podpisze ponownie, decyduje operator.
 */
const useGetAffectedConsents = (tourId: string | undefined) =>
  useGetTourConsents(tourId);

export default useGetAffectedConsents;
